import React, { useEffect, useState } from "react";
import { toolsAPI } from "../../utils/funcionesAPI";
import { manejadorDeRespuesta } from "../../utils/Tools";

const SelectorDireccionesFactura = (props) => {
  const {
    setFormulario,
    formularioSeleccionado,
    setFormularioSeleccionado,
  } = props;

  const token = sessionStorage.getItem("token");
  const [formulariosCargados, setFormulariosCargados] = useState([]);

  const getDatosDeFacturacion = () => {
    
    const data = JSON.stringify({
      accion: "traerDatosDeFacturacionDeClienteNuevo",
      token,
    });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        setFormulariosCargados(respuesta.data);
        if (respuesta.data.length > 0) {
          setFormularioSeleccionado(respuesta.data[0]);
          setFormulario(respuesta.data[0]);
        }
      }
    });
  };

  useEffect(() => {
    token && getDatosDeFacturacion();
  }, [token]);

  const handelChangeFormularioSeleccionado = (e) => {
    //setFormularioSeleccionado(formularioDefault);
    const idForm = e.target.value;
    const formularioSeleccionadoEncontrado = formulariosCargados.find(
      (form) => form.id === idForm
    );
    setFormularioSeleccionado(formularioSeleccionadoEncontrado);
    setFormulario(formularioSeleccionadoEncontrado);
  };

  return (
    <div className="from-group text-left bg" style={{ padding: "1rem" }}>
      {formulariosCargados.length > 0 ? (
        <div>
          <p style={{ fontWeight: "bold" }}>
            Seleccionar una direccion de facturacion creada anteriormente (puedes gestionar tus direcciones desde Mi Perfil)
          </p>
          <select
            name="formularioSeleccionado"
            className="custom-select"
            value={formularioSeleccionado.id}
            onChange={handelChangeFormularioSeleccionado}
          >
            <option value="0">Seleccionar direccion de facturacion</option>
            {formulariosCargados.map((form) => (
              <option
                value={form.id}
                key={form.id} 
              >{`${form.nombreResponsabilidad} - ${form.razonSocial} - ${form.tipoDocumento.sigla} ${form.numeroDocumento} - ${form.direccion}`}</option>
            ))}
          </select>
        </div>
      ) : (
        <p
          style={{
            backgroundColor: "#fafafa",
            width: "100%",
            fontWeight: "bold",
            padding: "10px",
          }}
        >
          No hay datos de facturacion cargados anteriormente. Debera cargar uno
          nuevo.
        </p>
      )}
    </div>
  );
};

export default SelectorDireccionesFactura;



// WEBPACK FOOTER //
// ./src/components/Global/SelectorDireccionesFactura.js